import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { ResizableWidgetComponent } from '../resizable-widget/resizable-widget.component';
import { Router } from '@angular/router';
import { DatePickerModule } from 'primeng/datepicker';
import { FormsModule } from '@angular/forms';
import { AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';
import { InventoryService } from 'app/inventory/services/inventory.service';
import { of } from 'rxjs';

@Component({
  selector: 'pcg-resizable-ndc-lookup-widget',
  imports: [
    FormsModule,

    AutoCompleteModule,
    DatePickerModule,

    ResizableWidgetComponent
  ],
  templateUrl: './resizable-ndc-lookup-widget.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: '../resizable-widget/resizable-widget.component.scss',
})
export class ResizableNdcLookupWidgetComponent {
    invService = inject(InventoryService);
    router = inject(Router);

    productName = signal<string | null>(null);
    ndc = signal<string | null>(null);
    lotNumber = signal<string | null>(null);
    expDate = signal<Date | null>(null);

    search() {
        if (
            !this.productName()
            && !this.ndc()
            && !this.lotNumber()
            && !this.expDate()
        ) return;

        this.router.navigate(['/ndcs/lookup'], {
            queryParams: {
                productName: this.productName(),
                ndc: this.ndc(),
                lotNumber: this.lotNumber(),
                expDate: this.expDate()
            }
        })
    }

    //#region Typeaheads
    productSuggestions = signal<string[]>([]);
    ndcSuggestions = signal<string[]>([]);

    onProductSearch(event: AutoCompleteCompleteEvent) {
        if (event.query.length < 2) {
            this.productSuggestions.set([]);
            return;
        }

        this.invService.getProductNameTypeahead(
            of(event.query)
        ).subscribe((r) => this.productSuggestions.set(r));
    }

    onNdcSearch(event: AutoCompleteCompleteEvent) {
        if (event.query.length < 2) {
            this.ndcSuggestions.set([]);
            return;
        }

        this.invService.getNdcTypeahead(
            of(event.query)
        ).subscribe((r) => this.ndcSuggestions.set(r));
    }
    //#endregion
}
